<template>
  <div class="content-panel">
    <div class="panel-title-wrap">
      <h3 class="panel-title">{{ $t("securityPanel.title") }}</h3>
      <span class="panel-sub">{{ $t("securityPanel.subtitle") }}</span>
    </div>
    <div class="security-list">
      <div class="security-item">
        <div class="security-info">
          <span class="security-icon">📱</span>
          <div>
            <div class="security-label">{{ $t("securityPanel.phoneBind") }}</div>
            <div class="security-desc">
              {{ profile.phone ? $t("securityPanel.phoneBound", { phone }) : $t("securityPanel.notBound") }}
            </div>
          </div>
        </div>
        <!-- <button class="btn-bind" @click="handleBindPhone">绑定</button> -->
      </div>
      <div class="security-item">
        <div class="security-info">
          <span class="security-icon">📧</span>
          <div>
            <div class="security-label">{{ $t("securityPanel.emailBind") }}</div>
            <div class="security-desc">
              {{ profile.email ? $t("securityPanel.emailBound", { email }) : $t("securityPanel.notBound") }}
            </div>
          </div>
        </div>
        <!-- <button class="btn-bind" @click="handleBindEmail">绑定</button> -->
      </div>
      <!-- ===== 两步验证 ===== -->
      <div class="security-item twofa-item">
        <div class="security-info">
          <span class="security-icon">🛡️</span>
          <div>
            <div class="security-label">{{ $t("securityPanel.twofa") }}</div>
            <div class="security-desc">
              {{
                profile.is_two_factor == 2
                  ? $t("securityPanel.twofaOn")
                  : $t("securityPanel.twofaOff")
              }}
            </div>
          </div>
        </div>
        <button
          class="btn-twofa"
          :class="twofa.enabled ? 'btn-twofa-on' : 'btn-twofa-off'"
          @click="handleToggleTwofa"
        >
          {{ twofa.enabled ? $t("securityPanel.twofaEnabled") : $t("securityPanel.enableTwofa") }}
        </button>
      </div>
    </div>

    <!-- ===== 两步验证弹窗 ===== -->
    <div
      class="modal-overlay"
      v-if="showTwofaModal"
      @click.self="closeTwofaModal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            {{ twofa.enabled ? $t("securityPanel.disableTwofaTitle") : $t("securityPanel.enableTwofaTitle") }}
          </h3>
          <button class="modal-close" @click="closeTwofaModal">✕</button>
        </div>
        <div class="modal-body">
          <!-- 开启两步验证 -->
          <template v-if="!twofa.enabled">
            <div class="twofa-setup">
              <div class="twofa-qr-placeholder">
                <div class="qr-code-sim">
                  <img
                    :src="twofaInfo.qrCode"
                    :alt="$t('securityPanel.qrAlt')"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </div>
              <p class="twofa-tip">
                {{ $t("securityPanel.tip1") }}
              </p>
              <p class="twofa-tip">{{ $t("securityPanel.tip2") }}</p>
              <div class="twofa-key-wrap">
                <span class="twofa-key">{{ twofaInfo.secret }}</span>
                <button class="btn-copy" @click="handleCopyKey">{{ $t("securityPanel.copy") }}</button>
              </div>
              <div class="form-row twofa-verify-row">
                <label class="form-label">{{ $t("securityPanel.verifyCode") }}</label>
                <div class="form-control-wrap">
                  <input
                    type="text"
                    v-model="twofaVerifyCode"
                    :placeholder="$t('securityPanel.verifyCodePlaceholder')"
                    class="form-input"
                    maxlength="6"
                  />
                </div>
              </div>
              <!-- 邮箱验证码 -->
              <div class="form-row twofa-verify-row">
                <label class="form-label">{{ $t("securityPanel.emailCode") }}</label>
                <div class="form-control-wrap">
                  <input
                    type="text"
                    v-model="emailCode"
                    :placeholder="$t('securityPanel.emailCodePlaceholder')"
                    class="form-input"
                    maxlength="6"
                  />
                  <button
                    class="btn-captcha"
                    @click="sendEmailCode"
                    :disabled="codeCountdown > 0"
                  >
                    {{
                      codeCountdown > 0
                        ? $t("securityPanel.resend", { count: codeCountdown })
                        : $t("securityPanel.sendCode")
                    }}
                  </button>
                </div>
              </div>
            </div>
          </template>
          <!-- 关闭两步验证 -->
          <template v-else>
            <div class="twofa-disable">
              <div class="disable-warning">⚠️</div>
              <p class="disable-text">
                {{ $t("securityPanel.disableWarning1") }}
              </p>
              <p class="disable-text">{{ $t("securityPanel.disableWarning2") }}</p>
              <div class="form-row twofa-verify-row">
                <label class="form-label">{{ $t("securityPanel.verifyCode") }}</label>
                <div class="form-control-wrap">
                  <input
                    type="text"
                    v-model="twofaVerifyCode"
                    :placeholder="$t('securityPanel.verifyCodePlaceholder')"
                    class="form-input"
                    maxlength="6"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn-modal-cancel" @click="closeTwofaModal">
            {{ $t("securityPanel.cancel") }}
          </button>
          <button
            class="btn-modal-confirm"
            :class="twofa.enabled ? 'btn-danger' : 'btn-success'"
            @click="handleConfirmTwofa"
          >
            {{ twofa.enabled ? $t("securityPanel.confirmDisable") : $t("securityPanel.confirmEnable") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SecurityPanel",
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
    twofa: {
      type: Object,
      default: () => ({
        enabled: false,
      }),
    },
  },
  data() {
    return {
      showTwofaModal: false,
      twofaVerifyCode: "",
      twofaInfo: {},
      // 邮箱验证码
      emailCode: "",
      codeCountdown: 0,
      codeTimer: null,
    };
  },
  beforeDestroy() {
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
    }
  },
  computed: {
    email() {
      return (
        this.profile.email.substring(0, 4) +
        "****" +
        this.profile.email.substring(8)
      );
    },
    phone() {
      return (
        this.profile.phone.substring(0, 3) +
        "****" +
        this.profile.phone.substring(7)
      );
    },
  },
  methods: {
    // ============================================================
    // 发送邮箱验证码
    // ============================================================
    async sendEmailCode() {
      if (this.codeCountdown > 0) return;

      // 调用发送邮箱验证码接口
      const res = await this.$api.code.sendUpdateCode({
        scene: "bind_twofa",
      });

      if (res.code == 1) {
        this.$message.warning(res.msg);
        return false;
      }

      this.$message.success(res.msg);

      // 开始倒计时
      this.codeCountdown = 60;
      this.codeTimer = setInterval(() => {
        this.codeCountdown--;
        if (this.codeCountdown <= 0) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
        }
      }, 1000);

      return true;
    },
    handleBindPhone() {
      console.log("绑定手机");
    },
    handleBindEmail() {
      console.log("绑定邮箱");
    },
    // ===== 两步验证 =====
    handleToggleTwofa() {
      this.twofaVerifyCode = "";

      //如果未开启两步验证
      if (!this.twofa.enabled) {
        this.$api.safety.get2FASecret().then((res) => {
          if (res.code === 1) {
            this.$message.error(res.msg || this.$t("securityPanel.getSecretFail"));
            return;
          }
          this.twofaInfo = res.data;
        });
      }

      this.showTwofaModal = true;
    },
    closeTwofaModal() {
      this.showTwofaModal = false;
      this.twofaVerifyCode = "";
      this.emailCode = "";
    },
    handleCopyKey() {
      navigator.clipboard
        ?.writeText(this.twofaInfo.secret)
        .then(() => {
          this.$message.success(this.$t("securityPanel.copySuccess"));
        })
        .catch(() => {
          this.$message.error(this.$t("securityPanel.copyFail"));
        });
    },
    handleConfirmTwofa() {
      if (!this.twofaVerifyCode || this.twofaVerifyCode.length !== 6) {
        this.$message.error(this.$t("securityPanel.enterVerifyCode"));
        return;
      }

      if (this.twofa.enabled) {
        // 关闭两步验证
        this.$api.safety
          .verify2FASecret({
            enabled: !this.twofa.enabled,
            code: this.twofaVerifyCode,
          })
          .then((res) => {
            if (res.code === 1) {
              this.$message.error(res.msg || this.$t("securityPanel.operationFail"));
              return;
            }

            this.$emit("update:twofa", {
              ...this.twofa,
              enabled: !this.twofa.enabled,
            });
            this.$message.success(
              !this.twofa.enabled ? this.$t("securityPanel.twofaEnabledMsg") : this.$t("securityPanel.twofaDisabledMsg"),
            );
            this.closeTwofaModal();
          });
      } else {
        // 开启两步验证 - 校验邮箱验证码
        if (!this.emailCode) {
          this.$message.error(this.$t("securityPanel.enterEmailCode"));
          return;
        }

        // 开启两步验证
        this.$api.safety
          .bind2FASecret({
            enabled: !this.twofa.enabled,
            secret: this.twofaInfo.secret,
            code: this.twofaVerifyCode,
            emailCode: this.emailCode,
          })
          .then((res) => {
            if (res.code === 1) {
              this.$message.error(res.msg || this.$t("securityPanel.operationFail"));
              return;
            }

            this.$emit("update:twofa", {
              ...this.twofa,
              enabled: !this.twofa.enabled,
            });
            this.$message.success(
              !this.twofa.enabled ? this.$t("securityPanel.twofaEnabledMsg") : this.$t("securityPanel.twofaDisabledMsg"),
            );
            this.closeTwofaModal();
          });
      }
    },
  },
};
</script>

<style scoped>
.content-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.panel-title-wrap {
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px 0;
}

.panel-sub {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.35);
}

/* ===== 账号安全 ===== */
.security-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.security-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.security-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.security-icon {
  font-size: 22px;
}

.security-label {
  font-size: 15px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

.security-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.35);
  margin-top: 2px;
}

.btn-bind {
  padding: 6px 20px;
  border-radius: 8px;
  background: rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.15);
  color: #00b4ff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-bind:hover {
  background: rgba(0, 180, 255, 0.2);
}

/* ===== 两步验证按钮 ===== */
.btn-twofa {
  padding: 6px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  border: none;
}

.btn-twofa-off {
  background: rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.15);
  color: #00b4ff;
}

.btn-twofa-off:hover {
  background: rgba(0, 180, 255, 0.2);
}

.btn-twofa-on {
  background: rgba(0, 201, 81, 0.1);
  border: 1px solid rgba(0, 201, 81, 0.15);
  color: #00c951;
}

.btn-twofa-on:hover {
  background: rgba(0, 201, 81, 0.2);
}

/* ===== 弹窗 ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #1a1f35;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  max-width: 480px;
  width: 90%;
  padding: 28px 32px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.modal-close {
  background: rgba(255, 255, 255, 0.06);
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 20px;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.modal-body {
  margin-bottom: 24px;
}

/* 两步验证 - 开启 */
.twofa-setup {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.twofa-qr-placeholder {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.qr-code-sim {
  width: 160px;
  height: 160px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 2px dashed rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.twofa-tip {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.twofa-tip:first-of-type {
  margin-top: 4px;
}

.twofa-key-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 8px 14px;
}

.twofa-key {
  flex: 1;
  font-family: "SF Mono", "Courier New", monospace;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 2px;
}

.btn-copy {
  padding: 4px 16px;
  border-radius: 6px;
  background: rgba(0, 180, 255, 0.1);
  border: none;
  color: #00b4ff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-copy:hover {
  background: rgba(0, 180, 255, 0.2);
}

/* 表单行（弹窗内） */
.form-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.form-label {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}

.form-control-wrap {
  flex: 1;
  display: flex;
  gap: 12px;
  align-items: center;
}

.form-input {
  flex: 1;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
  max-width: 400px;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.form-input:focus {
  border-color: rgba(0, 180, 255, 0.4);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(0, 180, 255, 0.05);
}

.twofa-verify-row {
  border-bottom: none;
  padding: 8px 0 0 0;
}

/* ===== 发送验证码按钮 ===== */
.btn-captcha {
  padding: 10px 20px;
  border-radius: 8px;
  background: rgba(0, 180, 255, 0.06);
  border: 1px solid rgba(0, 180, 255, 0.08);
  color: #00b4ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
  white-space: nowrap;
}

.btn-captcha:hover:not(:disabled) {
  background: rgba(0, 180, 255, 0.12);
}

.btn-captcha:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* 两步验证 - 关闭 */
.twofa-disable {
  text-align: center;
}

.disable-warning {
  font-size: 48px;
  margin-bottom: 12px;
}

.disable-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 4px 0;
  line-height: 1.6;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 20px;
}

.btn-modal-cancel {
  padding: 10px 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-modal-cancel:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.btn-modal-confirm {
  padding: 10px 32px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-success {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}

.btn-danger {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: #fff;
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(255, 107, 107, 0.3);
}

/* ===== 响应式 ===== */
@media (max-width: 480px) {
  .panel-title {
    font-size: 17px;
  }
  .security-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .modal-content {
    padding: 16px;
  }
  .modal-footer {
    flex-direction: column;
  }
  .btn-modal-cancel,
  .btn-modal-confirm {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}
</style>
